import apiClient from "./client";

export const dataPolicy = {
  getByToken: () => apiClient.get("/policies/gizlilik-politikasi"),
};
